/*
  Koleksiyon filtresi: koku ailesi (?koku=) + öne çıkan nota (?nota=).

  Filtreleme tarayıcıda yapılıyor: iki bilgi de üründe ayrı bir alan
  değil, başlığın içinde. Snippet filtreyi yalnızca tüm ürünler tek
  sayfadayken basıyor, dolayısıyla burada sayfada olmayan ürün yok.

  Grup içi mantık "veya" (Odunsu + Fujer = ikisinden biri), gruplar arası
  "ve" (Odunsu ailesi VE vanilya notası). Kullanıcı bir grupta seçenekleri
  genişletmek, gruplar arasında ise daraltmak istiyor.

  Seçim URL'de tutuluyor; bağlantı paylaşılabiliyor ve geri tuşu çalışıyor.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-adp-cf]');
  var grid = document.getElementById('main-collection-product-grid');
  if (!root || !grid) return;

  var GROUPS = ['koku', 'nota'];
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-adp-cf-key]'));
  var clearBtn = root.querySelector('[data-adp-cf-clear]');
  var emptyMsg = document.querySelector('[data-adp-cf-empty]');
  var countEl = document.querySelector('.results-count .count');

  function selected(group) {
    return chips
      .filter(function (c) {
        return c.getAttribute('data-adp-cf-group') === group && c.getAttribute('aria-pressed') === 'true';
      })
      .map(function (c) { return c.getAttribute('data-adp-cf-key'); });
  }

  function apply(push) {
    var picks = {};
    var any = false;
    GROUPS.forEach(function (g) {
      picks[g] = selected(g);
      if (picks[g].length) any = true;
    });

    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .product'));
    var shown = 0;

    items.forEach(function (li) {
      var ok = GROUPS.every(function (g) {
        var keys = picks[g];
        if (!keys.length) return true;
        var have = (li.getAttribute('data-adp-' + g) || '').split(' ');
        return keys.some(function (k) { return have.indexOf(k) !== -1; });
      });

      if (ok) {
        li.removeAttribute('data-adp-hidden');
        shown++;
      } else {
        li.setAttribute('data-adp-hidden', '');
      }
    });

    if (countEl) countEl.textContent = String(shown);
    if (emptyMsg) emptyMsg.hidden = shown !== 0;
    if (clearBtn) clearBtn.hidden = !any;

    if (push) {
      var url = new URL(window.location.href);
      GROUPS.forEach(function (g) {
        if (picks[g].length) {
          url.searchParams.set(g, picks[g].join(','));
        } else {
          url.searchParams.delete(g);
        }
      });
      history.pushState({ adpFilter: 1 }, '', url);
    }
  }

  function readUrl() {
    var params = new URL(window.location.href).searchParams;
    var wanted = {};
    GROUPS.forEach(function (g) {
      wanted[g] = (params.get(g) || '').split(',').filter(Boolean);
    });
    chips.forEach(function (c) {
      var g = c.getAttribute('data-adp-cf-group');
      var on = wanted[g] && wanted[g].indexOf(c.getAttribute('data-adp-cf-key')) !== -1;
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      apply(true);
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      apply(true);
    });
  }

  window.addEventListener('popstate', function () {
    readUrl();
    apply(false);
  });

  readUrl();
  apply(false);
})();
